import LazyLoad from "../../../Image/LazyLoad";

const ThumbnailGallery = ({ block, toggleGallery }) => {
	return (
		<div className="thumbnailGallery">
			{block.data.children.map((child, i) => {
				const asset = child.data;

				return (
					<div
						className={`item itemSize-${asset.size}`}
						data-size={asset.size}
						key={
							asset.thumbnail !== null && asset.thumbnail.length !== 0
								? asset.thumbnail.id
								: asset.image.id
						}
						onClick={() => toggleGallery(i)}
					>
						{asset.thumbnail !== null && asset.thumbnail.length !== 0 ? (
							<LazyLoad key={asset.thumbnail.id} image={asset.thumbnail} containVideoOverlay={!!asset['video']} />
						) : (
							<LazyLoad key={asset.thumbnail.id} image={asset.image} containVideoOverlay={true} />
						)}
					</div>

				);
			})}
		</div>
	);
};

export default ThumbnailGallery;